<template>
	<v-app>

		<Nav/>

		<v-container class="landing-description container-wrapper">

			<v-row
				class="pt-6 text-sm-left text-center"
			>
					
				<v-col cols="12" sm="6">
					<h1>Mano turinys</h1>
				</v-col>

				<v-col cols="12" sm="2" class="pt-6">
					<v-btn small color="primary" rounded v-on:click="showAtlasSummaryForm">
						Kurti naują atlasą
					</v-btn>
				</v-col>

			</v-row>

			<v-row
				class="pt-6 text-sm-left text-center"
			>

				<v-col cols="12" sm="8">

					<template v-if="loading">
						<v-progress-circular
							indeterminate
							color="primary"
							:size="40"
							width="2"
						></v-progress-circular>
					</template>
					<template v-else>
						<v-row>
							<v-col class="pa-0">
								<template v-if="list == 'error'">
									<div>Deja, atlasų sąrašo gauti nepavyko...</div>
								</template>
								<template v-else>
									<ListFilter
										:list="list"
										:setFilteredList="setFilteredList"
										:filterType="true"
										class="px-4 mb-10"
									>
										<div v-if="filteredList && filteredList.length">
											<v-btn
												color="error"
												text
												outlined
												small
												:disabled="!deleteButtonVisible"
												v-on:click="deleteAtlases"
												:loading="deleteInAction"
											>
												<v-icon left size="18">mdi-delete</v-icon>
												Pašalinti pažymėtus atlasus
											</v-btn>
										</div>
									</ListFilter>
									<template v-for="(atlas, i) in filteredList">
										<AtlasPreview
											:atlas="atlas"
											:key="i"
											:class="[i ? '' : '']"
											:getList="getList"
											:editable="true"
											:onCheckStatusChange="onAtlasCheckStatusChange"
											ref="atlasPreview"
										/>
									</template>
								</template>
							</v-col>
						</v-row>
					</template>
					<AtlasSummaryForm />
					<CommonComponents />
					<AtlasSharingForm />

				</v-col>

				<v-col cols="12" sm="4">

					<InfoHelpVertical />

				</v-col>

			</v-row>
		
		</v-container>

		<v-footer class="white">
			<Footer />
		</v-footer>

	</v-app>
</template>

<script>
	import Nav from "../header/PageNav";
	import Footer from "../footer/FooterTitle";
	import AtlasHelper from "../helpers/AtlasHelper";
	import AtlasSummaryForm from "../atlas/AtlasSummaryForm";
	import AtlasSharingForm from "../atlas/AtlasSharingForm";
	import AtlasPreview from "../atlas/AtlasPreview";
	import CommonComponents from "../CommonComponents";
	import ListFilter from "../ListFilter";
	import InfoHelpVertical from "../gui-elements/InfoHelpVertical";

	export default {
		components: {
			Nav,
			Footer,
			AtlasSummaryForm,
			AtlasSharingForm,
			AtlasPreview,
			CommonComponents,
			ListFilter,
			InfoHelpVertical
		},
		data: function(){
			var data = {
				loading: true,
				list: null,
				filteredList: null,
				deleteButtonVisible: false,
				deleteInAction: false
			};
			return data;
		},
		created(){
			this.getList();
		},
		methods: {
			showAtlasSummaryForm: function(){
				// Sukūrus atlasą galimi kaip ir du visai logiški scenarijai:
				// 1) Atnaujinamas atlasų sąrašas
				// 2) Einama į ką tik sukurto atlaso "edit" puslapį...
				this.$vBus.$emit("show-atlas-summary-form", {
					callback: this.editAtlas || this.getList
				});
			},
			getList: function(){
				this.loading = true;
				AtlasHelper.getList().then(function(list){
					this.loading = false;
					this.list = list;
				}.bind(this), function(){
					this.loading = false;
					this.list = "error";
				}.bind(this));
			},
			setFilteredList: function(filteredList){
				this.filteredList = filteredList;
			},
			editAtlas: function(response){
				if (response["atlasID"]) {
					this.$router.push("/atlas/" + response["atlasID"] + "/edit");
				}
			},
			onAtlasCheckStatusChange: function(){
				var someChecked = false;
				if (this.$refs.atlasPreview) {
					this.$refs.atlasPreview.some(function(item){
						if (item.checked) {
							someChecked = true;
							return true;
						}
					});
				}
				this.deleteButtonVisible = someChecked;
			},
			deleteAtlases: function(){
				if (this.$refs.atlasPreview) {
					var atlasesIds = [],
						atlases = [];
					this.$refs.atlasPreview.forEach(function(item){
						if (item.checked) {
							atlasesIds.push(item.atlas["atlasID"]);
							atlases.push(item.atlas);
						}
					});
					var positiveCallback = function(){
						this.deleteInAction = true;
						AtlasHelper.deleteAtlases(atlasesIds).then(function(){
							this.getList();
							this.deleteInAction = false;
							// TODO: reikia scroll'o į viršų
						}.bind(this), function(){
							this.$vBus.$emit("show-message", "error");
							this.deleteInAction = false;
						}.bind(this));
					}.bind(this);
					AtlasHelper.deleteAtlasesConfirmation(positiveCallback, this.$vBus, atlases);
				}
			}
		}
	};
</script>